import { GLOBAL_REFRESH, SET_CUSTOMER_NAME } from "./action";
import { isValidCustomerName } from "services/route.service";

export const defaultState = {
  customerName: null,
};

function HomeReducer(state = defaultState, action) {
  switch (action.type) {
    case SET_CUSTOMER_NAME: {
      const value = action.payload;
      return isValidCustomerName(value)
        ? { ...state, customerName: value }
        : state;
    }
    case GLOBAL_REFRESH:
      return state;
    default:
      return state;
  }
}

export default HomeReducer;
